<template>
    <div class="integralTicketBox">
        <md-tab-bar
                v-model="current"
                :items="items"
        />
        <div class="scrollBoxi">
            <div class="scrollContent">
                <div @click="goToIntegralTicketConvertFn(item)" class="integral integralState1" v-for="(item, index) in newTicketList" :key="index">
                    <div class="left">
                        <div class="number numberState1">
                            <span>{{item.subTitile}}</span>
                        </div>
                        <div class="textBox">
                            <div class="jifeng numberState1">元</div>
                            <div class="quan quanState1">
                                <span>{{item.title}}</span>
                                <span class="credits">{{item.ticketScore}}积分</span>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="text-left textState1">
                            <span v-if="item.cardType == '001'">商场券</span>
                            <span v-if="item.cardType == '002'">品牌券</span>
                            <span v-if="item.cardType == '003'">停车券</span>
                        </div>
                        <div class="text-right textState1">
                            <span>有效期：{{item.beginDate}} ~ {{item.endDate}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "integralTicket",
        mounted() {
            document.title = "积分换券",
                this.$http.get('/sangto-wrm/vip/scoreCoupons/sync').then(()=>{ //同步一下
                    this.$http.post('/sangto-wrm/vip/scoreCoupons/currentTicket').then(({data})=>{ //券信息
                        this.ticketList = data.data.rows
                    })
                })

        },
        data(){
          return{
              current: 1, //tab切换标识
              items: [{name: 1, label: '商场券'}, {name: 2, label: '品牌券'},{name: 3, label: '停车券'}],
              ticketList:[],//卡券信息
          }
        },
        computed:{
            newTicketList(){
                return this.ticketList.filter(item =>{
                        if(item.subTitile.toString().indexOf('面值')>-1){
                            let str = item.subTitile.replace('面值:', '')

                            item.subTitile = Math.floor(str)
                        }else{
                            item.subTitile = Math.floor(item.subTitile)
                        }

                        item.beginDate = item.beginDate.split(' ')[0]
                        item.endDate = item.endDate.split(' ')[0]
                        if(item.ticketNum>0){
                            if(this.current == 1 && item.cardType == '001'){ //过滤
                                return item
                            }
                            if(this.current == 2 && item.cardType == '002'){
                                return item
                            }
                            if(this.current == 3 && item.cardType == '003'){
                                return item
                            }
                        }


                })
            }
        },
        methods: {

            goToIntegralTicketConvertFn(item) {
                let it = JSON.stringify(item)
                this.$router.push({path:'/appMain/integralTicketConvert',query:{itemData:it}})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .integralTicketBox {
        position: relative;
        width: 100%;
        height: 100%;

        .scrollBoxi {
            position: absolute;
            top: 50px;
            left: 0;
            right: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
            background-color: #fdfdfd;
        }
        .scrollContent {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .integral {
            position: relative;
            width: 90%;
            height: 110px;
            margin-top: 19px;
            border-radius: 5px;
            display: flex;
            align-items: center;
            flex-direction: column;
            background:#fff;
        }

        .integralState1 {
            box-shadow: 0px 0px 9px rgba(14, 131, 240,0.2);
        }

        .left {
            width: 92%;
            height: 69%;
            border-bottom: 1px solid #ddd;
            display: flex;
        }

        .numberState1 {
            color: rgb(14, 131, 242);
        }

        .number {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-size: 38px;
            font-weight: 600;
        }

        .textBox {
            flex: 3;
            display: flex;
            flex-direction: column;
        }

        .jifeng {
            font-size: 14px;
            margin-top: 24px;
            margin-left: 8px;
        }

        .numberState1 {
            color: rgb(14, 131, 242);
        }

        .quanState1 {
            color: #333;
        }

        .quan {
            font-size: 14px;
            margin-left: 8px;
            display: flex;
            justify-content: space-between;
        }

        .credits {
            padding-top: 10px;
            color: #55bab4;
            font-weight: bold;
        }

        .right {
            width: 92%;
            height: 31%;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .text-left {
            font-size: 14px;
            flex: 1;
        }

        .textState1 {
            color: #666;
        }

        .text-right {
            flex: 2;
            font-size: 12px;
            display: flex;
            justify-content: flex-end;

        }
    }
</style>
